import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  parentContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "20px",
    padding: "44px",
  },
  sectionHeader: {
    marginBottom: "-80px",
    marginTop: "1px",
    padding: "50px",
    width: "100%",
    textAlign: "left",
  },
  valueContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "5px",
    width: "100%",
    flexWrap: "wrap",
  },
  companyInfoContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  docContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    width: "100%",
  },
  divider: {
    marginBottom: "60px !important",
  },
  header: {
    marginLeft: "30px",
    fontSize: "18px",
    fontWeight: 700,
    marginTop: "20px",
  },
  photoDisplay: {
    width: "80%",
  },
  photo: {
    width: "100%",
    marginBottom: "10px",
  },

  personCard: {
    width: "400px",
  },
  textInput: {
    ".mantine-Input-input:disabled": {
      backgroundColor: "#fff",
      color: "#000",
    },
  },
  deleteButton: {
    marginLeft: "35px",
    fontSize: "16px",
    fontWeight: 700,
    marginTop: "10px",
    color: theme.colors.red[6],
    cursor: "pointer",
  },
}));
